export default "__VITE_ASSET__DThA2K5j__"